import { MenuPresets } from '@framework/form/inputs/rich-text/menu/MenuPresets.tsx';
import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { TbIcon } from '@framework/ui/components/icon/TbIcon.tsx';
import { IconTemplate } from '@tabler/icons-react';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { RichTextAdvancedInput } from '../../../../../inputs/rich-text-advanced/RichTextAdvancedInput.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { type IWidgetConfigurationSlot } from '../../common/config-slots/IWidgetConfigurationSlot.ts';
import { WidgetConfigurationSlotRender } from '../../common/config-slots/WidgetConfigurationSlotRender.tsx';
import { CodeLabelInputForm } from '../../inputs/common/CodeLabelInputForm.tsx';
import { SubsectionEditor } from './components/SubsectionEditor.tsx';
import { type ISubsectionWidget } from './ISubsectionWidget.ts';
import { SubsectionRendering } from './SubsectionRendering.ts';
import { SubsectionConfigContainer } from './style/SubsectionConfigContainer.tsx';

/** Card "Editor Sottosezione": editor drag&drop del contenuto. */
const SubsectionEditorSlot: IWidgetConfigurationSlot = {
  key: 'subsection-editor',
  title: 'Editor Sottosezione',
  icon: <TbIcon icon={IconTemplate} />,
  description: 'Composizione dei campi contenuti nella sottosezione.',
  order: 15,
};

export interface ISubsectionConfigComponentProps
  extends IWidgetComponentProps<ISubsectionWidget> {}

export function SubsectionConfigComponent(
  props: ISubsectionConfigComponentProps,
) {
  const renderingKind = useWatch({ name: 'rendering' }) as SubsectionRendering;

  const renderingHelp = useMemo(() => {
    switch (renderingKind) {
      case SubsectionRendering.Drawer:
        return 'La sottosezione verrà visualizzata in un pannello dedicato';
      case SubsectionRendering.Inline:
        return 'La sottosezione verrà visualizzata in linea nel modulo';
      case SubsectionRendering.Hidden:
        return 'La sottosezione verrà nascosta e visibile attraverso azione dedicata';
      default:
        return '';
    }
  }, [renderingKind]);

  return (
    <>
      <div>
        <FormItem name="rendering" label="Visualizzazione" help={renderingHelp}>
          <SelectInput
            name="rendering"
            defaultValue={SubsectionRendering.Drawer}
            options={[
              {
                label: 'Pannello dedicato',
                value: SubsectionRendering.Drawer,
              },
              { label: 'In linea', value: SubsectionRendering.Inline },
              { label: 'Nascosta', value: SubsectionRendering.Hidden },
            ]}
          />
        </FormItem>
        <CodeLabelInputForm hideLabel hideColSpan />

        <FormItem name="label" label="Titolo">
          <RichTextAdvancedInput
            name="label"
            menus={MenuPresets.Inline}
            rows={3}
          />
        </FormItem>
        {renderingKind === SubsectionRendering.Drawer && (
          <FormItem name="placeholder" label="Testo pulsante">
            <TextInput name="placeholder" defaultValue="Apri" />
          </FormItem>
        )}
        {/* <FormItem name="viewInResume" layout={{ removeLabelSpace: true }}>
              <CheckboxInput name="viewInResume" defaultChecked={false}>
                Visualizza sottosezione in riepilogo compilazione
              </CheckboxInput>
            </FormItem> */}
      </div>

      <WidgetConfigurationSlotRender slot={SubsectionEditorSlot}>
        <SubsectionConfigContainer>
          {/* Editor DnD dei componenti */}
          <SubsectionEditor renderingKind={renderingKind} />
        </SubsectionConfigContainer>
      </WidgetConfigurationSlotRender>
    </>
  );
}
